import React from "react";

const LogoBetweenLines = ({ logoSource, height = 48 }) => (
  <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
    }}
  >
    <img
      src={logoSource}
      alt="Logo"
      style={{
        height: `${height}px`,
        width: "auto",
        maxWidth: "100%",
        objectFit: "contain",
        display: "block",
        margin: "0 auto",
      }}
    />
  </div>
);

export default LogoBetweenLines;
